import React, { Component } from "react";

import Img from "react-image";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class EntertaimentCardItem extends Component {
  render() {
    const { src, title, link, width } = this.props;
    return (
      <div className={`col-${width} entertainment-card-item`}>
        <Link to={link}>
          <Img src={src} alt={title} />
        </Link>
      </div>
    );
  }
}
EntertaimentCardItem.propType = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default EntertaimentCardItem;



// WEBPACK FOOTER //
// ./src/components/entertainment-card.js